// Fields requested from operationsSearch when loading jobs for the Tools screen
export const OPERATIONS_SEARCH_SELECT_FIELDS = [
  'LinkedNcFiles',
  'PartId',
  'PartNumber',
  'ProductionOperationId',
  'ProductionOperationNumber',
  'ProductionOrderId',
  'ProductionOrderNumber',
];
